import React from 'react';
import { Route } from 'react-router-dom';
import PatientCheckIn from '../components/PatientCheckIn';
import PatientCheckInSuccess from '../components/PatientCheckInSuccess';

export const checkInRoutes = [
  <Route key="check-in" path="/check-in" element={<PatientCheckIn />} />,
  <Route key="check-in-success" path="/check-in-success" element={<PatientCheckInSuccess />} />
]; 